
<template>
	<c-dialog ref="dialog" title="选择产品库存批次" width="1200" height="700" enable-flex @resolve="resolve">
	    <view-list work-type="18" view-id="10019" ref="view" selector :selected-field="{name: 'product_name'}">
	    	<template #search>
	    		<m-search ref="search" column="4" :init-data="initSearchData" :default-data="defaultSearchData" :extend-data="extendSearchData" @clear="$refs.warehouseRef.setValueData(warehouseOptions)">
				    <m-search-item label="仓库">
					    <c-select name="warehouse_id" async ref="warehouseRef" @search="searchWarehouse" :value-data="warehouseOptions" :disabled="disabledWarehouse"></c-select>
				    </m-search-item>
	    			<m-search-item label="产品编号">
	    				<c-input name="product_code"></c-input>
	    			</m-search-item>
	    			<m-search-item label="产品名称">
	    				<c-input name="product_name"></c-input>
	    			</m-search-item>
	    			<m-search-item label="产品规格">
	    				<c-input name="product_spec"></c-input>
	    			</m-search-item>
					<m-search-item label="批次号">
						<c-input name="batch_code"></c-input>
					</m-search-item>
					<m-search-item>
						<c-checkbox-group name="is_stock">
							<c-checkbox value="1">仅查询有库存</c-checkbox>
						</c-checkbox-group>
					</m-search-item>
	    		</m-search>
	    	</template>
	    
			<template #product_source="{data}">
				<c-state dict="productSourceName" :value="data.product_source"></c-state>
			</template>
		
	    	<template #product_type="{data}">
	    		<c-state dict="productTypeName" :value="data.product_type"></c-state>
	    	</template>
	    </view-list>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
	    name: 'productBatchSelector',

		props: {
			warehouseOptions: Array,
			isStock: Boolean,
			initParam: Object,
			extendParam: Object,
			disabledWarehouse: Boolean
		},

		data() {
			return {
				initSearchData: this.initParam,
				defaultSearchData: {
					'is_stock': this.isStock ? [1] : []
				},
				extendSearchData: this.extendParam
			}
		},
		
		computed: {
			...mapState(['productSourceName', 'productTypeName'])
		},
		
		methods: {
			open() {
				this.$refs.view.reset();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.view.selectedData;
				if (!data.length) {
					stop();
					this.$message({
						message: '请选择产品批次库存'
					});
					return;
				}
				this.$emit('resolve', data);
			},
			
			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>